import React, { memo, useCallback } from "react";
import UnifiedSearch from "./UnifiedSearch";
import SearchErrorBoundary from "./SearchErrorBoundary";
import "./SearchBar.css";

function SearchBarContainer({ onSearch }) {
    const handleSearch = useCallback((q, opts) => onSearch?.(q, opts), [onSearch]);
    return (
        <div className="search-wrap">
            <div className="dual-search-bar">
                <SearchErrorBoundary>
                    <UnifiedSearch onSearch={handleSearch} defaultMode="ai" />
                </SearchErrorBoundary>
            </div>
        </div>
    );
}

export default memo(SearchBarContainer);